<template>
    <div role="form">
        <div v-if="state.currentView == 'QR_INIT_VIEW' && state.processing != true">
            <h5
                class="container__col-md-12 container__col-sm-12 payment__instruction"
            >
                {{$t("qr.init.instruction")}}
            </h5>
            <PrimaryButton 
                :content="
                    [$t('ui.pay.btn'), state.currency, state.amount.toLocaleString()]
                        .filter(Boolean)
                        .join(' ')
                "
                @click="Next"
            />
        </div>
        <div
            class="qr"
            v-else-if="
                state.currentView == 'QR_CODE_VIEW' &&
                    state.processing != true &&
                    !showProcessing
            "
        >
            <div class="payment__body__success-img">
                <figure class="qr-visa">
                    <img
                        :src="state.qrCode"
                        alt="qr code"
                        class="container__col-sm-12 container__col-md-12 qr-visa__img"
                        loading="lazy" 
                        decoding="async"
                    />
                </figure>
                <p
                    class="container__col-md-12 container__col-sm-12 payment__instruction"
                >
                    {{$t("qr.scan.instruction")}}
                </p>
                <figure class="qr-code">
                    <img
                        :src="state.qrCode"
                        alt="qr code"
                        class="container__col-sm-12 container__col-md-12 qr-code__img"
                        loading="lazy" 
                        decoding="async"
                    />
                </figure>
                <PrimaryButton
                    :content="$t('ui.redirect.btn')"
                    @click="toggleProcessing"
                />
            </div>
        </div>
        <template
            v-else-if="
                state.currentView == 'QR_CODE_VIEW' &&
                    state.processing != true &&
                    showProcessing
            "
        >
            <payment-loading />
        </template>
    </div>
</template>

<script>
import { injectStore, mapState } from "redux-vuex";
import { ref, onBeforeUnmount, watch, onUpdated } from "vue";

import { getValueFromPath, autoInitialize } from "@/support/helpers";
// import PaymentSuccessful from "@/components/common/payment-successful";
import PrimaryButton from "@/components/form/base-button";
import PaymentLoading from "@/components/payment-loading.vue";
export default {
    name: "QrPayment",
    components: {
        PaymentLoading,
        PrimaryButton,
    },
    setup() {
        const store = injectStore();
        const checkoutData = ref(store.getState());
        const transactionSuccessful = ref(false);
        const showProcessing = ref(false);
        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });

        function Next() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }
        function toggleProcessing() {
            Next();
            showProcessing.value = true;
        }
        
        const autoInitializePayment = autoInitialize("QR_INIT_VIEW");

        onUpdated(() =>  autoInitializePayment(checkoutData, Next));

        watch(checkoutData, (val) => {
            if (
                val.view != undefined &&
        val.view.current != "QR_CODE_VIEW" &&
        checkoutData.value.processing != true
            ) {
                showProcessing.value = false;
            }
        });
        onBeforeUnmount(() => {
            subscription();
        });
        return {
            state: mapState({
                processing: (state) => getValueFromPath(state, "processing") || false,
                qrCode: (state) =>
                    getValueFromPath(state, "view.context.qrcode") || null,
                currentView: (state) => getValueFromPath(state, "view.current") || null,
                amount: (state) => getValueFromPath(state, "amount") || null,
                currency: (state) =>
                    getValueFromPath(state, "currency.current") || null,
            }),
            toggleProcessing,
            showProcessing,
            transactionSuccessful,
            Next,
        };
    },
};
</script>

<style lang="scss" scoped>
.qr {
  display: flex;
  // height: 500px;
  flex-direction: column;
}
.qr-visa {
  width: 60%;
  margin: 0 auto;
  margin-bottom: 10px;
  &__img {
    width: 100%;
    height: 50px;
    object-fit: cover;
    object-position: 5% 0%;
  }
}
.qr-code {
  width: 70%;
  overflow: hidden;
  margin: 0 auto;
  &__img {
    width: 100%;

    object-fit: cover;
    object-position: 0% 100%;
    image-rendering: pixelated;
    @media screen and (max-width: 320px) {
      height: 180px;
    }
    @media screen and (min-width: 360px) and (max-width: 375px) {
      height: 200px;
    }
    @media screen and (min-width: 375px) and (max-width: 420px) {
      height: 230px;
    }
    @media screen and (min-width: 421px) {
      height: 250px;
    }
    @media screen and (min-width: 768px) and (max-width: 1024px) {
      height: 230px;
    }

    // clip: rect(110px, 160px, 170px, 60px); /* or "auto" */
    //     /* values descript a top/left point and bottom/right point */
    //     /* current version (doesn't require positioning) */
    //     clip-path: inset(10px 20px 30px 40px);

    //     // clip: rect(110px, 160px, 170px, 60px);
    //     // /* -webkit-clip-path: inset(10px 20px 30px 40px); */
    //     // clip-path: inset(107px 0px 0px 0px)
  }
}
.payment__instruction {
  margin-bottom: 5px;
}
</style>